var handleDocumentCategories = function handleDocumentCategories() {
  var formCategories = document.querySelector('[data-form="categories"]');
  if (formCategories) {
    formCategories.addEventListener('submit', function (e) {
      e.preventDefault();
      var target = e.target;
      var categoriesId = target.querySelector('[data-element="formCategoriesSubmit"]').dataset.value;
      var categoriesCheckboxes = Array.from(target.querySelectorAll('input[type="checkbox"]:checked'));
      var labelNames = categoriesCheckboxes.map(function (item) {
        return item.nextElementSibling.textContent;
      });
      var categoriesHndls = categoriesCheckboxes.map(function (item) {
        return item.value;
      });
      var tableHolder = document.querySelector('[data-element="tableHolder"]');
      var tableRowId = document.querySelector("[data-table-row-id=\"".concat(categoriesId, "\"]"));
      var newParameters = "categories?fileId=".concat(categoriesId, "&identifiers=").concat(categoriesHndls);
      var tableRowCategories = tableRowId.querySelector('[data-table="categories"]');
      tableRowCategories.textContent = labelNames.length ? labelNames.join(', ') : '—';
      tableRowId.querySelector('[data-modal]').dataset.modal = newParameters;
      target.closest('[data-micromodal-close]').click();
      tableHolder.classList.add('is-loading');
      fetch('/actions/nlr/my-documents/categories', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: "categories[]=".concat(categoriesHndls, "&fileId=").concat(categoriesId, "&").concat(window.csrfTokenName, "=").concat(window.csrfTokenValue)
      }).then(function (response) {
        if (response.ok) {
          tableHolder.classList.remove('is-loading');
        }
      })["catch"](function (error) {
        console.log(error);
      });
    });
  }
};
window.initCategoriesGroup = function () {
  handleDocumentCategories();
};